import { render, staticRenderFns } from "./HouseTypeCofig.vue?vue&type=template&id=59dda494&scoped=true&"
import script from "./HouseTypeCofig.vue?vue&type=script&lang=js&"
export * from "./HouseTypeCofig.vue?vue&type=script&lang=js&"
import style0 from "./HouseTypeCofig.vue?vue&type=style&index=0&id=59dda494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dda494",
  null
  
)

export default component.exports